import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import 'Flow2/components/Article/Utilities/Dropdown/Dropdown.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';
import { injectIntl } from 'react-intl';
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';

class CustomDropdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    createDDItems = (data) => {
        let newData = data.map(item => {
            let name = item.username ? item.username : '';
            if (item.first_name && item.last_name) name = item.first_name + ' ' + item.last_name;
            let value = item.id || '';
            return { name, value }
        });
        newData.unshift({ name: "All", value: "CustomSearchAll" })
        this.setState({ [`${this.props.name}data`]: newData });
    }

    getSearchOptions = () => {
        if (this.props.datalist && this.props.datalist === ArticleTypes.USERLIST) {
            if (this.props.users && this.props.users.length) {
                let data = this.props.users;
                if (this.props.rolelist) {
                    let list = this.props.rolelist.split(";");
                    if (list && list.length) {
                        data = data.filter(item => list.some(el => el === item.role));
                    }
                }
                this.createDDItems(data);
            }
        } else {
            if (this.props[`${this.props.name}`] && this.props[`${this.props.name}`].length)
                this.createDDItems(this.props[`${this.props.name}`]);
        }
    }

    getDataForDD = () => {
        if (this.props.data && this.props.data.length) this.setState({ [`${this.props.name}data`]: this.props.data || [] })
        else if (this.props.type === ArticleTypes.SEARCH) this.getSearchOptions();
    }

    onDDIconClick = (name) => {
        if (!this.state[`${name}Display`] || this.state[`${name}Display`] === ArticleTypes.NONE) this.setState({ [`${name}Display`]: ArticleTypes.BLOCK })
        else if (this.state[`${name}Display`] === ArticleTypes.BLOCK) this.setState({ [`${name}Display`]: ArticleTypes.NONE });
    }

    getDDClasses = () => {
        if (this.props.styleClasses) return `custom-dropdowncontainer ${this.props.styleClasses}`;
        if (this.props.sortSelectStyle) return "custom-dropdowncontainer custom-sortselect";
        return "custom-dropdowncontainer"
    }

    getDDReqClasses = () => {
        if (this.props.isRequired) return "custom-dropdown-required";
        return "custom-dropdown";
    }

    renderItems = () => {
        if (this.state[`${this.props.name}data`] && this.state[`${this.props.name}data`].length) {
            return (
                <ul>
                    {this.state[`${this.props.name}data`].map(item => {
                        let displayName = item.intl ? this.props.intl.formatMessage({ id: item.intl }) : item.name
                        let searchtype = this.props.searchtype ? this.props.searchtype : "=";
                        return (<li name={item.id} value={item.value}
                            onClick={this.props.onDDItemClick.bind(this, this.props.name, displayName, item.value, searchtype)}>
                            {displayName}
                        </li>)
                    })}
                </ul>)
        }

        return (<div></div>)
    }

    setUpMainSortByDD = (current) => {
        const { field, sorted } = this.props.articleObjects.articlesSortByData;
        if (field && sorted) {
            current = this.props.intl.formatMessage({ id: `metadata.article.${field}${sorted.toUpperCase()}` })
            this.props.setCustomCurrentSortOption(`${field}|${sorted}`);
        }
        return current;
    }

    setCurrentOptionForDD = () => {
        let current = this.props.current ? this.props.current : null;
        if (this.props.articleObjects && this.props.articleObjects.articlesSortByData
            && this.props.name === ArticleTypes.SORTBY) {
            current = this.setUpMainSortByDD(current);
        }

        if (this.props.customCurrentSortOption && this.props.customCurrentSortOption !== ArticleTypes.SORTING) {
            this.props.setCustomCurrentSortOption(ArticleTypes.SORTING);
        }
        if (!current) {
            if (this.props.showChoose) current = this.props.intl.formatMessage({ id: `data.article.choose` });
            else current = this.props.intl.formatMessage({ id: `data.article.${this.props.name}` });
        }
        this.setState({ [`${this.props.name}Current`]: current })
    }

    closeAllDropDowns = () => {
        for (let el in this.state) {
            if (el.includes("Display")) this.setState({ [el]: ArticleTypes.NONE });
        }
    }

    componentDidMount() {
        this.getDataForDD();
        this.setCurrentOptionForDD();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.users && prevProps.users != this.props.users) {
            this.getDataForDD();
        }

        if ((prevProps.current && (prevProps.current !== this.props.current))
            || (!prevProps.current && this.props.current)) {
            if (this.props.trigger || this.props.current === this.props.intl.formatMessage({ id: "data.article.sortby" })) {
                this.setState({ [`${this.props.name}Display`]: ArticleTypes.NONE });
            }
            else this.onDDIconClick(this.props.name);
            //this.setState({ [`${this.props.name}Current`]: this.props.current });

            if (this.props.current) this.setState({ [`${this.props.name}Current`]: this.props.current });
            else this.setState({ [`${this.props.name}Current`]: this.props.intl.formatMessage({ id: `data.article.${this.props.name}` }) });
        }

        if (prevProps.lg && (prevProps.lg !== this.props.lg)) {
            this.setCurrentOptionForDD();
        }

    }

    render() {
        return (
            <div className={this.getDDClasses()}>
                <div className="custom-dropdownbox">
                    <div className={this.getDDReqClasses()}>
                        <div className="custom-dropdownhead custom-flex-between" name="ddbody"
                            onClick={this.onDDIconClick.bind(this, this.props.name)} >
                            <span>{this.state[`${this.props.name}Current`]}</span>
                            <FontAwesomeIcon icon={faSortDown} />
                        </div>
                        <div className="custom-dropdownbody"
                            style={{ display: this.state[`${this.props.name}Display`] }}>
                            {this.renderItems()}
                        </div>
                    </div>
                </div>
            </div>)
    }

}

const mapStateToProps = (state) => ({
    metadataConfig: state.metadata.config,
    users: state.admin.users,
    articleObjects: state.article.articleObjects,
    customCurrentSortOption: state.customData.customCurrentSortOption,
    lg: state.ui.language
})

const mapDispatchToProps = (dispatch) => ({
    setCustomCurrentSortOption: (option) => dispatch(actions.setCustomCurrentSortOption(option))
})
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CustomDropdown));